import axiosInstance from '../../../../config/axiosInstance';
const handleSubmitForCheckbox = async (ClientID,RoleID, checkboxState, redirectCallback, redirectAssignModules) => {
   try {
        const formData = { checkboxState, ClientID: ClientID,RoleID:RoleID };
        const response = await axiosInstance.post(`/SuperAdmin/AssigFormToCompany`, formData);
    } catch (error) {
        console.error('Error saving checkbox data:', error);
    }
};

export default handleSubmitForCheckbox; 